<script lang="ts" setup>
// #右圖左文
import { type Text } from '@/utils/types/TextEditor'
import { type Image } from '@/utils/types/Image'
const props = defineProps({
  data: {
    type: Object
  }
})

const textData = ref()
const imgData = ref()

if (props.data) {
  const text: Ref<Text> = ref(props.data.text)
  const img: Ref<Image> = ref(props.data.image)
  textData.value = text.value
  imgData.value = img.value
}
</script>

<template>
  <div class="area">
    <div class="area__left">
      <div class="area__text" v-html="textData"></div>
    </div>
    <figure class="area__pic">
      <Nimg :src="imgData?.link" :title="imgData?.title" :alt="imgData?.alt" format="webp" />
    </figure>
  </div>
</template>

<style lang="scss" scoped>
.area {
  display: flex;
  align-items: center;
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  @include max-media(580) {
    flex-direction: column;
  }

  &__pic,
  &__left {
    width: 50%;

    @include max-media(580) {
      width: 100%;
    }
  }

  &__pic {
    img {
      display: block;
      width: 100%;
    }
  }

  &__left {
    padding-right: 15%;

    @include max-media(580) {
      padding: 0 toRem(30) toRem(30);
    }
  }

  &__title {
    margin-bottom: toRem(15);
    font-weight: 500;
    font-size: toRem(28);
    line-height: 1.3;

    @include max-media(580) {
      font-size: toRem(22);
    }
  }
}
</style>
